import { SBack, SListTabs } from 'shj-components'
import AccountList from './accountList'
import MoneyChangeConfig from './moneyChangeConfig'
import { useRequest } from 'ahooks'
import { httpCompanyList } from '@/services/homeService'

export default function () {
  let { data: companyList = [] } = useRequest(httpCompanyList)
  let {data: allCompanyList = []} = useRequest(httpCompanyList, {
    defaultParams: [{status: ''}],
});

  const items = [
    {
      key: '1',
      label: '质保金账户列表',
      children: <AccountList companyList={companyList} allCompanyList={allCompanyList}/>,
    },
    {
      key: '3',
      label: '质保金配置',
      children: <MoneyChangeConfig companyList={companyList} allCompanyList={allCompanyList}/>,
    },
  ]
  return (
    <>
      <SBack title="质保金管理" />
      <SListTabs items={items} hideExtra={false} auth={false} />
    </>
  )
}
